var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaListingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-listing-icon_svg__a",
    d: "M0 0h45v45.001H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-listing-icon_svg__c",
    d: "M0 60h59.063V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-listing-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-listing-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5c0 12.427-10.074 22.501-22.5 22.501S0 34.927 0 22.501C0 10.072 10.074 0 22.5 0S45 10.073 45 22.5",
    fill: "#F8D7CC",
    mask: "url(#ea-listing-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25 48.75H16.877a1.874 1.874 0 01-1.875-1.874V16.877c0-1.036.839-1.875 1.875-1.875H56.25c1.036 0 1.875.84 1.875 1.875v29.999a1.874 1.874 0 01-1.875 1.875",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.877 15.94a.939.939 0 00-.938.937v29.999c0 .516.421.937.938.937H56.25c.517 0 .937-.42.937-.937V16.877a.938.938 0 00-.937-.937H16.877zM56.25 49.688H16.877a2.816 2.816 0 01-2.813-2.812V16.877a2.816 2.816 0 012.813-2.812H56.25a2.816 2.816 0 012.812 2.812v29.999a2.816 2.816 0 01-2.812 2.812zM58.125 11.252h-47.81a.938.938 0 010-1.875h47.81a.937.937 0 110 1.875",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.439 15.94a.938.938 0 01-.938-.938V9.377a.938.938 0 011.875 0v5.625c0 .518-.42.938-.937.938M48.75 15.94a.937.937 0 01-.937-.938V9.377a.937.937 0 111.875 0v5.625a.937.937 0 01-.938.938M30.001 26.252h-1.875v-4.688c0-.517.42-.937.938-.937h3.75v1.875H30v3.75z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.001 30.001h-1.875v-3.75c0-.517.42-.937.938-.937h3.75v1.875H30v2.812zM42.188 25.314h.937c.518 0 .938-.42.938-.937v-.938a.938.938 0 00-.938-.937h-.937v2.812zm.937 1.875h-1.874a.937.937 0 01-.938-.937v-4.688c0-.517.42-.937.938-.937h1.874a2.816 2.816 0 012.813 2.812v.938a2.816 2.816 0 01-2.813 2.812z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.938 30.001h-1.875v-.937c0-1.034-.841-1.875-1.875-1.875v2.812h-1.875v-3.75c0-.517.42-.937.938-.937h.937a3.754 3.754 0 013.75 3.75v.937z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-listing-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-listing-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-listing-icon_svg__d)",
    d: "M45.938 39.376h4.687v-1.875h-4.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.563 44.063h-5.625a.937.937 0 01-.938-.937V33.75c0-.517.42-.937.938-.937h5.625v1.875h-4.688v7.5h4.688v1.874zM35.626 22.502v5.624h1.876l-.001-5.624h-1.875zm1.875 7.5h-1.875a1.877 1.877 0 01-1.875-1.876v-5.624c0-1.034.84-1.875 1.875-1.875H37.5c1.034 0 1.875.84 1.875 1.875v5.624c0 1.035-.841 1.875-1.875 1.875zM26.251 44.063h-1.875a2.816 2.816 0 01-2.812-2.812h1.875c0 .516.42.937.937.937h1.875c.517 0 .938-.42.938-.937v-.523a.937.937 0 00-.642-.89l-3.06-1.02a2.809 2.809 0 01-1.923-2.668v-.524a2.816 2.816 0 012.812-2.812h1.875a2.816 2.816 0 012.813 2.812h-1.875a.939.939 0 00-.938-.937h-1.875a.939.939 0 00-.937.937v.524c0 .404.258.761.641.889l3.06 1.02a2.808 2.808 0 011.924 2.669v.523a2.816 2.816 0 01-2.813 2.812M37.5 44.063h-1.874v-8.437a.939.939 0 00-.938-.937h-1.875a.939.939 0 00-.937.937v8.437H30v-8.437a2.816 2.816 0 012.812-2.812h1.875a2.816 2.816 0 012.813 2.812v8.437z",
    fill: "#020303",
    mask: "url(#ea-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-listing-icon_svg__d)",
    d: "M30.939 40.313h5.625V38.44h-5.625zM44.063 44.063h-4.687a.937.937 0 01-.938-.937V32.814h1.875v9.374h3.75v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#ea-listing-icon_svg__d)",
    d: "M5.628 54.375h4.687V5.628H5.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.565 53.438h2.812V6.565H6.565v46.873zm3.75 1.875H5.628a.937.937 0 01-.938-.938V5.628c0-.518.42-.938.938-.938h4.687c.517 0 .937.42.937.938v48.747c0 .518-.42.938-.937.938z",
    fill: "#020303",
    mask: "url(#ea-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.064 59.063H1.877v-1.875a2.812 2.812 0 012.813-2.813h6.562a2.812 2.812 0 012.812 2.813v1.875z",
    fill: "#E74A10",
    mask: "url(#ea-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.815 58.125h10.312v-.937c0-1.034-.841-1.875-1.875-1.875H4.69c-1.034 0-1.875.84-1.875 1.875v.937zM14.065 60H1.876a.938.938 0 01-.937-.937v-1.875a3.754 3.754 0 013.75-3.75h6.562a3.754 3.754 0 013.75 3.75v1.875c0 .517-.42.937-.938.937z",
    fill: "#020303",
    mask: "url(#ea-listing-icon_svg__d)"
  }))));
}
export default SvgEaListingIcon;